<script>
    import StipulationListener from "@/service/StipulationListener"
    import { applicationState, providerState, sessionState } from "@/state"
    import { applyService } from "@/service"

    export default {
        data: () => ({
            stipulations: [],
            stipulationListener: null
        }),

        computed: {
            isStipulationPending () {
                return this.pendingStipulation != null
            },

            pendingStipulation () {
                let stipulationType = this.getStipulationType()

                if (!stipulationType) {
                    return
                }

                let stipulations = this.stipulations

                if (!stipulations) {
                    return null
                }

                return stipulations.find(stip => {
                    return stip.type === stipulationType && stip.status === 'pending'
                })
            }
        },

        async created () {
            await this.refreshStipulations()

            if (this.pendingStipulation) {
                this.stipulationListener = new StipulationListener(sessionState.providerKey, this.pendingStipulation.id)

                this.stipulationListener.onStipulationCompleted(() => {
                    providerState.updateStipulation(sessionState.providerKey, Object.assign(this.pendingStipulation, {status: 'completed'}))
                    this.onStipulationCompleted()
                })

                this.stipulationListener.init()
            }
        },

        destroyed () {
            if (this.stipulationListener) {
                this.stipulationListener.destroy()
            }
        },

        methods: {
            async refreshStipulations () {
                let { stipulations } = await applyService.refreshStipulations(sessionState.providerKey, { application: applicationState.application })
                providerState.setStipulations(sessionState.providerKey, stipulations)
                this.stipulations = stipulations
            },

            getStipulationType () {
                // override this
            },

            onStipulationCompleted () {
                // override if needed
            }
        }
    }
</script>
